import { render, staticRenderFns } from "./EditLiveEditSettingsTab.vue?vue&type=template&id=31ebb49f"
import script from "./EditLiveEditSettingsTab.vue?vue&type=script&lang=js"
export * from "./EditLiveEditSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports